:host {
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    select:focus,
    textarea:focus,
    input:focus {
      font-size: 16px;
    }
  }

  .message-select {
    display: flex;
    flex-direction: column;

    .message-select {
      width: 100%;
    }

    span {
      display: block;
      margin-bottom: 10px;
      color: #666666;
      color: var(--font-secondary);
    }

    select {
      font-size: 14px;
      box-sizing: border-box;
      min-height: 40px;
      border: 1px solid #e0e0e0;
      border: 1px solid var(--divider);
      border-radius: 4px;
      background-color: #ffffff;
      background-color: var(--bg-primary);
      padding: 8px 15px;
      color: #666666;
      color: var(--font-secondary);
      width: 100%;

      &:focus {
        outline: none;
      }
    }
  }
}
